<template>
  <div id="BoardingsStep">
    <v-card elevation="1" class="pa-1 pt-0">
      <div class="d-flex pa-2 pt-1 list-container">
        <v-card class="column pa-1">
          <div class="d-flex justify-space-between align-center column-title px-3">
            <div class="d-flex align-center">
              <h1 style="color: black">Cargas</h1>
              <v-divider v-show="!isCollapsed" vertical class="mx-2 my-1"></v-divider>
              <span v-show="!isCollapsed" class="mb-0 mt-1 font-weight-medium caption mr-2"
                >{{ unallocatedCargos.length }} itens</span
              >
              <v-tooltip right nudge-top="1">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-checkbox
                      v-if="!isCollapsed"
                      v-model="selectAllCargos"
                      :disabled="unallocatedCargos.length === 0"
                      class="custom-checkbox pa-0 ma-0"
                      hide-details
                      @change="toggleSelectAllCargos"
                    ></v-checkbox>
                  </div>
                </template>
                <span>Selecionar todas</span>
              </v-tooltip>
            </div>
            <div class="d-flex align-center">
              <span v-if="unallocatedCargos.length > 0">
                <v-tooltip v-if="!isCollapsed" right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="ml-3" @click="isCollapsed = !isCollapsed"
                      >mdi-chevron-double-left</v-icon
                    >
                  </template>
                  <span>Recolher</span>
                </v-tooltip>
                <v-tooltip v-else right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="isCollapsed = !isCollapsed">
                      mdi-chevron-double-right
                    </v-icon>
                  </template>
                  <span>Expandir</span>
                </v-tooltip>
              </span>
            </div>
          </div>
          <div v-if="isCollapsed" class="d-flex justify-space-between align-center px-3">
            <v-checkbox
              v-model="selectAllCargos"
              label="Selecionar todas"
              :disabled="unallocatedCargos.length === 0"
              class="custom-checkbox collapsed pa-0 ma-0"
              hide-details
              @change="toggleSelectAllCargos"
            ></v-checkbox>
            <v-divider vertical class="mx-1 my-1"></v-divider>
            <span class="mb-0 font-weight-medium caption">{{ unallocatedCargos.length }} itens</span>
          </div>
          <v-divider class="mx-2 my-1"></v-divider>
          <v-text-field
            v-show="!isCollapsed"
            class="custom-search px-2"
            label="Buscar"
            color="black"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
            single-line
            v-model="searchQueryUnallocated"
            @keydown.enter="performSearch('unallocated')"
            @click:prepend-inner="performSearch('unallocated')"
          ></v-text-field>
          <div v-if="isUnallocatedLoading" class="px-2">
            <v-progress-linear indeterminate />
          </div>
          <div
            class="deliveries-container pa-2 pt-0 justify-center"
            :style="{ height: isCollapsed ? '540px' : '530px', width: isCollapsed ? '240px' : '370px' }"
          >
            <drag-card-cargos
              :cargos="filteredUnallocatedCargos"
              :isCollapsed="isCollapsed"
              :selectedCargo="selectedCargos"
              @update:selected="updateCargoSelection"
              @update:selectedDeliveries="selectedCargos = $event"
              @update:selectAll="selectAllCargos = $event"
            />
          </div>
        </v-card>
        <div class="w-100 column pa-1">
          <div class="d-flex justify-space-between align-center column-title px-3">
            <div class="d-flex align-center">
              <h1 style="color: black">Embarques</h1>
              <v-divider vertical class="mx-2 my-1"></v-divider>
              <v-label class="pb-0 pt-1 mr-2 font-weight-medium black--text" style="font-size: 14px"
                >{{ filteredBoardings.length }} itens</v-label
              >
              <v-checkbox
                v-model="selectAllBoardings"
                label="Selecionar todas"
                :disabled="filteredBoardings.length === 0"
                class="custom-checkbox collapsed pa-0 ma-0 mt-1"
                hide-details
                @change="toggleSelectAllBoarding"
              />
            </div>
          </div>
          <v-divider class="mx-2 my-1"></v-divider>
          <v-text-field
            v-show="boardings.length > 0"
            class="custom-search px-2"
            label="Buscar"
            color="black"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
            single-line
            v-model="searchQueryBoarding"
            @keydown.enter="performSearch('boarding')"
            @click:prepend-inner="performSearch('boarding')"
          ></v-text-field>
          <div v-if="isBoardingLoading" class="px-2">
            <v-progress-linear indeterminate />
          </div>
          <div v-if="!boardings.length > 0" class="selected-container d-flex align-center justify-center rounded mb-2">
            <v-icon size="60" color="" style="padding-bottom: 3px">mdi-emoticon-neutral-outline</v-icon>
            <div class="d-flex flex-column ml-2">
              <span class="text-h5">Nenhum embarque criada até o momento.</span>
              <span class="text-subtitle-1 font-weight-regular">
                Crie um
                <a
                  class="new-import-delivery text-decoration-underline"
                  target="_blank"
                  rel="noopener noreferrer"
                  @click="$emit('isDialogFormOpen', true)"
                  >novo embarque</a
                >
                para prosseguir.
              </span>
            </div>
          </div>
          <div class="d-flex justify-center align-center py-3" v-else-if="filteredBoardings.length == 0">
            Nenhum embarque encontrado
          </div>
          <div class="stop-container" v-else>
            <BoardingHierarchy
              ref="BoardingHierarchy"
              v-for="item in virtualBoardingsList"
              :boarding="item"
              :selected="selectedBoardings[item.id]"
              :key="item.id"
              @update:selected="updateBoardingSelection"
              @update:selectAll="selectAllBoardings = $event"
              @input="item.alocatedDeliveries = $event"
              @update:allocated="updateUnallocated"
              @update:editBoarding="editBoarding"
              @removeBoarding="removeBoarding(item.id)"
            />
            <div v-if="filteredBoardings.length" v-observe-visibility="handleBoardingsScroll"></div>
          </div>
          <div class="px-2 mt-2"></div>
        </div>
      </div>
    </v-card>
    <confirm-dialog
      :isOpen="isOpenConfirmationComputed || isOpenConfirmDeleteComputed"
      @confirmClick="confirmClick"
      :title="titleConfirmation"
      @cancelClick="cancel"
      :body-text="bodyText"
    />
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import DragCardCargos from '@/components/ManualBoardingImport/Stepper/Step6/DragCardCargos.vue';
import BoardingHierarchy from '@/components/ManualBoardingImport/Stepper/Step6/BoardingHierarchy.vue';
import ConfirmDialog from '@/components/ConfirmDialog';
import MessagesError from '@/components/MessagesError.vue';
import { mapActions } from 'vuex';
import maskWeight from '@/utils/maskWeight';
import maskCPF from '@/utils/maskCPF';
import maskCNPJ from '@/utils/maskCNPJ';
export default {
  name: 'BoardingsStep',
  components: {
    DragCardCargos,
    BoardingHierarchy,
    ConfirmDialog,
    MessagesError
  },
  props: {
    isOpenConfirmation: {
      type: Boolean,
      default: false
    },
    isOpenConfirmDelete: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isUnallocatedLoading: false,
    isBoardingLoading: false,
    unallocatedCargos: [],
    boardings: [],
    boardingsToShow: 5,
    filteredUnallocatedCargos: [],
    filteredBoardings: [],
    selectAllCargos: false,
    selectAllBoardings: false,
    selectedCargos: {},
    selectedBoardings: {},
    searchQueryUnallocated: '',
    searchQueryBoarding: '',
    isCollapsed: true,
    errors: [],
    errorsType: 'error',
    error500: null
  }),
  mounted() {
    this.fetchUnallocatedCargos();
    this.fetchBoarding();
  },
  watch: {
    boardings: {
      handler() {
        this.checkAndEmit();
      }
    },
    unallocatedCargos: {
      handler() {
        this.checkAndEmit();
      }
    },
    filteredUnallocatedCargos: {
      handler() {
        this.selectAllCargos ? this.toggleSelectAllCargos() : this.updateSelectAllCargos();
      }
    },
    filteredBoardings: {
      handler() {
        this.selectAllBoardings ? this.toggleSelectAllBoarding() : this.updateSelectAllBoardings();
      }
    },
    searchQueryUnallocated: {
      handler(value) {
        if (value === '') {
          this.filteredUnallocatedCargos = this.unallocatedCargos;
        }
      }
    },
    searchQueryBoarding: {
      handler(value) {
        if (value === '') {
          this.filteredBoardings = this.boardings;
        }
      }
    },
    selectedBoardings: {
      handler() {
        this.$emit('selectedBoardingsIds', this.selectedBoardingsIds);
      }
    }
  },
  computed: {
    parameterID() {
      return this.$route.params.id;
    },
    isOpenConfirmationComputed: {
      get() {
        return this.isOpenConfirmation;
      },
      set(value) {
        this.$emit('update:isOpenConfirmation', value);
      }
    },
    isOpenConfirmDeleteComputed: {
      get() {
        return this.isOpenConfirmDelete;
      },
      set(value) {
        this.$emit('update:isOpenConfirmDelete', value);
      }
    },
    selectedCargosIds() {
      return Object.keys(this.selectedCargos).filter((id) => this.selectedCargos[id]);
    },
    selectedBoardingsIds() {
      return Object.keys(this.selectedBoardings).filter((id) => this.selectedBoardings[id]);
    },
    virtualBoardingsList() {
      return this.filteredBoardings.slice(0, this.boardingsToShow);
    },
    titleConfirmation() {
      if (this.isOpenConfirmDeleteComputed) {
        return 'Desfazer Cargas';
      } else {
        return 'Confirmar embarque(s) criadas';
      }
    },
    bodyText() {
      if (this.isOpenConfirmDeleteComputed) {
        const selectedBoardings = this.boardings.filter((cte) => this.selectedBoardingsIds.includes(cte.id));
        const numbers = selectedBoardings.map((boarding) => boarding.boardingNumber);
        return `Confirmar desalocar as cargas relacionadas e o descarte das embarques:${numbers.slice(0, 15)}${
          numbers.length > 15 ? '...' : ''
        }?`;
      } else {
        return `Você confirma os dados dos ${this.boardings.length} embarque(s)?`;
      }
    }
  },
  methods: {
    ...mapActions('ImportManualBoardingsStore', [
      'getAllUnallocatedCargos',
      'getAllBoarding',
      'createNewBoarding',
      'createGroupedCargos',
      'deleteBoarding',
      'deleteMultipleBoardings'
    ]),

    async fetchUnallocatedCargos() {
      try {
        this.isUnallocatedLoading = true;
        const data = await this.getAllUnallocatedCargos(this.parameterID);
        this.unallocatedCargos = data;
        this.filteredUnallocatedCargos = data;
        await this.filterCargos();
      } catch (err) {
        console.error(err);
      } finally {
        this.isUnallocatedLoading = false;
      }
    },
    async fetchBoarding() {
      try {
        this.isBoardingLoading = true;
        const data = await this.getAllBoarding(this.parameterID);
        this.boardings = data;
        this.filteredBoardings = data;
        this.checkAndEmit();
        await this.filterBoardings();
      } catch (err) {
        console.error(err);
      } finally {
        this.isBoardingLoading = false;
      }
    },
    async addBoarding(value) {
      this.$emit('isCreateStopLoading', true);
      try {
        const model = {
          processId: this.parameterID,
          ...value
        };
        const response = await this.createNewBoarding(model);
        if (response.success) {
          this.errors = ['Embarque criado com sucesso!'];
          this.errorsType = 'success';
        } else {
          this.errors = response.errors || ['Erro ao criar embarque'];
          this.errorsType = 'error';
        }
        this.fetchBoarding();
      } catch (err) {
        console.error(err);
      } finally {
        this.$emit('isCreateStopLoading', false);
      }
    },
    async editBoarding(response) {
      if (response.success) {
        this.errors = ['Embarque editado com sucesso!'];
        this.errorsType = 'success';
      } else {
        this.errors = response.errors || ['Erro ao editar embarque'];
        this.errorsType = 'error';
      }
      await this.fetchBoarding();
      this.checkAndEmit();
    },
    async removeBoarding(id = null, multi = false) {
      try {
        const response = multi
          ? await this.deleteMultipleBoardings(this.selectedBoardingsIds)
          : await this.deleteBoarding(id);
        if (response.success) {
          this.errors = [`${multi ? 'Embarques deletadas' : 'Embarque deletada'} com sucesso!`];
          this.errorsType = 'success';
          this.selectedBoardings = {};
        } else {
          this.errors = response.errors || ['Erro ao deletar embarque(s)'];
          this.errorsType = 'error';
        }
        await this.fetchUnallocatedCargos();
        await this.fetchBoarding();
        await this.checkAndEmit();
      } catch (err) {
        console.error(err);
      } finally {
        this.isUnallocatedLoading = false;
      }
    },
    toggleSelectAllCargos() {
      this.selectedCargos = {};
      this.unallocatedCargos.forEach((delivery) => {
        this.$set(this.selectedCargos, delivery.id, this.selectAllCargos);
      });

      this.updateSelectAllCargos();
    },
    updateCargoSelection(id) {
      this.$set(this.selectedCargos, id, !this.selectedCargos[id]);
      this.updateSelectAllCargos();
      this.checkAndEmit();
    },
    updateSelectAllCargos() {
      this.selectAllCargos =
        this.unallocatedCargos.length > 0
          ? this.unallocatedCargos.every((delivery) => this.selectedCargos[delivery.id])
          : false;
      this.checkAndEmit();
    },

    toggleSelectAllBoarding() {
      this.selectedBoardings = {};
      this.filteredBoardings.forEach((boarding) => {
        this.$set(this.selectedBoardings, boarding.id, this.selectAllBoardings);
      });
      this.updateSelectAllBoardings();
    },
    updateSelectAllBoardings() {
      this.selectAllBoardings =
        this.filteredBoardings.length > 0
          ? this.filteredBoardings.every((boarding) => this.selectedBoardings[boarding.id])
          : false;
      this.$emit('selectedBoardingsIds', this.selectedBoardingsIds);
      this.checkAndEmit();
    },
    updateBoardingSelection(id) {
      this.$set(this.selectedBoardings, id, !this.selectedBoardings[id]);
      this.updateSelectAllBoardings();
    },
    performSearch(type) {
      if (type === 'unallocated') {
        this.filterCargos();
      } else if (type === 'boarding') {
        this.filterBoardings();
      }
    },
    filterCargos() {
      const query = this.searchQueryUnallocated ? this.searchQueryUnallocated.toLowerCase() : '';
      const queryNormalized = query.replace(/[^\d]/g, '');
      if (query === '') {
        this.filteredUnallocatedCargos = this.unallocatedCargos;
      } else {
        const normalizeValue = (value) => (value ? value.replace(/[^\d]/g, '') : '');
        this.filteredUnallocatedCargos = this.unallocatedCargos.filter((cargo) => {
          const isPartialEntregaDireta = 'entrega direta'.includes(query) && cargo.transhipmentName === null;
          const isPartialTransbordo = 'transbordo'.includes(query) && cargo.transhipmentName !== null;

          return (
            isPartialEntregaDireta ||
            isPartialTransbordo ||
            (cargo.cargoNumber && cargo.cargoNumber.toString().toLowerCase().includes(query)) ||
            (cargo.transhipmentName && cargo.transhipmentName.toLowerCase().includes(query)) ||
            (cargo.totalPriceNfes && normalizeValue(maskWeight(cargo.totalPriceNfes)).includes(queryNormalized)) ||
            (cargo.weightDeliveries && `${maskWeight(cargo.weightDeliveries)}Kg`.toLowerCase().includes(query)) ||
            (cargo.amountStops && cargo.amountStops.toString().toLowerCase().includes(query))
          );
        });
      }
    },
    filterBoardings() {
      const query = this.searchQueryBoarding ? this.searchQueryBoarding.toLowerCase() : '';
      const queryNormalized = query.replace(/[^\d]/g, '');

      if (query === '') {
        this.filteredBoardings = this.boardings;
      } else {
        this.filteredBoardings = this.boardings.filter((boarding) => {
          const normalizeValue = (value) => (value ? value.replace(/[^\d]/g, '') : '');
          return (
            (boarding.boardingNumber && boarding.boardingNumber.toString().toLowerCase().includes(query)) ||
            (boarding.directDelivererName && boarding.directDelivererName.toLowerCase().includes(query)) ||
            boarding?.totalMileage?.toString().toLowerCase().includes(query) ||
            (boarding.freightPrice && normalizeValue(maskWeight(boarding.freightPrice)).includes(queryNormalized)) ||
            normalizeValue(maskWeight(boarding?.totalPriceCargos || 0)).includes(queryNormalized) ||
            normalizeValue(maskWeight(boarding?.totalDeliveriesPrice || 0)).includes(queryNormalized) ||
            normalizeValue(maskWeight(boarding?.totalNfesPrice || 0)).includes(queryNormalized) ||
            normalizeValue(maskWeight(boarding?.totalTranshipmentsPrice || 0)).includes(queryNormalized) ||
            (boarding?.weightCargos &&
              `${maskWeight(boarding?.weightCargos || 0)}Kg`.toString().toLowerCase().includes(query)) ||
            (boarding.amountCargos && boarding.amountCargos.toString().toLowerCase().includes(query))
          );
        });
      }
    },
    cancel() {
      this.isOpenConfirmationComputed = false;
      this.isOpenConfirmDeleteComputed = false;
    },
    confirmClick() {
      if (this.isOpenConfirmDeleteComputed) {
        this.removeBoarding(null, this.selectedBoardingsIds);
        this.isOpenConfirmDeleteComputed = false;
      } else {
        this.$emit('confirmClick');
      }
    },
    checkAndEmit() {
      const hasStops = this.boardings.length > 0;
      const hasStopsWithDeliveries = this.boardings.some((boarding) => boarding.amountCargos > 0);
      const hasStopsWithoutDeliveries = this.boardings.filter((boarding) => boarding.amountCargos == 0);
      let message = '';
      let errorValidate = false;
      if (!hasStops) {
        message = 'Crie pelo menos um embarque';
        errorValidate = true;
      } else if (!hasStopsWithDeliveries) {
        message = 'Nenhuma embarque com cargas alocadas';
        errorValidate = true;
      } else if (hasStopsWithoutDeliveries.length > 0) {
        const numbers = hasStopsWithoutDeliveries.map((boarding) => boarding.boardingNumber).join(', ');
        message = `Embarques(s) de N° ${numbers} devem ter ao menos uma carga alocada`;
        errorValidate = true;
      }
      this.$emit('step5Finished', errorValidate, message);
    },
    handleBoardingsScroll(isVisible) {
      if (!isVisible || this.boardingsToShow >= this.filteredBoardings.length) return;
      this.boardingsToShow += 5;
    },
    async updateUnallocated(msg, success) {
      if (success) {
        this.errors = [msg];
        this.errorsType = 'success';
        this.selectedCargos = {};
        this.selectAllCargos = false;
      } else {
        this.errors = [msg];
        this.errorsType = 'info';
      }
      await this.fetchUnallocatedCargos();
      if (this.unallocatedCargos.length === 0) {
        this.isCollapsed = true;
      }
      await this.fetchBoarding();
      this.checkAndEmit();
    },
    transformCpfOrCnpj(str) {
      if (str.length === 11) {
        return maskCPF(str);
      }

      return maskCNPJ(str);
    }
  }
};
</script>
<style lang="scss" scoped>
.list-container {
  width: 100%;
  height: 638px;
}

.selected-container {
  width: 100%;
  height: 520px;
}
.card-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 1rem;
  width: 100%;
}
.stop-container {
  width: 100%;
  height: auto;
  max-height: 540px;
  overflow-y: auto;
  overflow-x: hidden;
}
.selected-card {
  box-shadow: 0 2px 4px rgba(23, 23, 23, 0.18);
  border: solid 1px #4299e1;
  color: #4299e1;
  h4,
  .v-icon path {
    color: #4299e1;
    fill: #4299e1;
  }
}
.column-title {
  width: 100%;
  text-align: left;
}

.deliveries-container {
  width: 100%;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
}
.deliveries-container::-webkit-scrollbar,
.stop-container::-webkit-scrollbar {
  width: 8px;
  height: 5px;
  background-color: #f5f5f5;
}

.deliveries-container::-webkit-scrollbar-track,
.stop-container::-webkit-scrollbar-track {
  padding-left: 1px;
  padding-right: 1px;
  background-color: #f5f5f5;
}

.deliveries-container::-webkit-scrollbar-thumb,
.stop-container::-webkit-scrollbar-thumb {
  background-color: #999999;
  border-radius: 8px;
}
.deliveries-container::-webkit-scrollbar-thumb:hover,
.stop-container::-webkit-scrollbar-thumb:hover {
  background-color: #0f426e9d;
}
.ghost-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
.icon {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
.new-import-delivery {
  color: #4299e1;
}
::v-deep .custom-checkbox .v-label {
  font-weight: 500;
  font-size: 14px;
  color: black;
}
::v-deep .v-input {
  input {
    max-height: 40px;
    .v-input__slot .v-input__prepend-inner {
      position: relative;
      top: 0px;
    }
  }
  .v-text-field {
    &__slot {
      margin: 0;
      padding: 0;

      input,
      textarea {
        border: none;
        border-radius: none;
        padding: 0 0px;
        box-shadow: none;
        background: none;

        &:focus,
        &:hover {
          background: none;
          border-color: none;
        }
      }

      .v-label {
        position: relative;
        transform: translateY(0px);
        top: auto;
        color: black;
      }
    }
  }
}

::v-deep .custom-checkbox .collapsed .v-input--selection-controls__input {
  margin-right: 0px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
